<template>

  <v-container class="align-center flex-row mb-6 pa-0">

    <p class="text-headline-small mb-4">Identificazione</p>


    <v-select @update:modelValue="classeChanged" v-model="properties.classe_id" :items="baseData.lookup.classefauna"
        label="Classe" hide-details class="mb-6" item-title="label" />

    <v-select @update:modelValue="specieChanged" v-model="properties.specie_id" :items="specie_filtered"
        item-title="label" label="Specie" hide-details 
    >  
  </v-select>
  <v-switch v-model="in_direttiva" label="In direttiva" color="success" inset hide-details @update:modelValue="properties.specie_id = null" class="mb-6"  />

    <v-number-input v-if="properties.classe_id == 3" v-model="properties.quota" label="Quota" type="number"
        :min="0" :max="5000" :placeholder="'0'" :step="10" class="mb-6" />

    <v-select v-model="properties.segni_id" :items="baseData.lookup.segni" label="Segni" item-title="label" hide-details
        class="mb-6" />
  </v-container>






  <v-card class="ma-0 mb-6 pa-3" :border="true" flat>
    <p class="text-headline-small">Prelievo</p>
    <SamplePick v-model:properties="properties" :timestamp="properties.real_timestamp" />

  </v-card>



  <v-card class="ma-0 pa-3" :border="true" flat>
    <p class="text-headline-small">Quantità</p>

    <PopulationCounter v-model:properties="properties" />

  </v-card>

  <!-- 
  <v-container class="align-center flex-row mb-6 pa-2 bg-grey-lighten-4">
    <p class="text-headline-small">Quantità inline</p>
    <p class="">
      <v-number-input label="Maschio" v-model="properties.q_male" :min="0" :max="30" class="mb-6" />
      <v-number-input label="Femmina" v-model="properties.q_female" :min="0" :max="30" class="mb-6" />
      <v-number-input label="Giovane" v-model="properties.q_young" :min="0" :max="30" class="mb-6" />
      <v-number-input label="Piccolo" v-model="properties.q_kid" :min="0" :max="30" class="mb-6" />
      <v-number-input label="Indeterminato" v-model="properties.q_undefined" :min="0" :max="30" class="mb-6" />
      <v-text-field :readonly="true" v-model:totalecontofauna="totalecontofauna" type="number" />
    </p>

  </v-container> -->

  <SegnalazioneCommon v-model="properties" />
</template>

<script setup>

import { ref, computed, onMounted } from 'vue'

import { useBrowserSession } from "@/store/browserSession"
import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import SamplePick from "@/reports/components/SamplePick";

import PopulationCounter from "@/reports/components/PopulationCounter";


import baseData from '@/assets/catalog/TrackerForms.json'
import { nextTick } from 'vue';
// import { useDisplay } from 'vuetify'
// const { mobile } = useDisplay()

const emit = defineEmits(['update:model-value'])


const properties = defineModel()
const totalecontofauna = defineModel("totalecontofauna")

const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})

//Coturnice
//Biacco
//Lepre variabile
//Parnassius apollo
//Gracchio corallino
//Coronella austriaca
//stambecco
//Euplagia quadripunctaria
//Fagiano di monte
//Rana temporaria
//camoscio
//Euphidryas aurinia
//Picchio nero
//Lucertola
//Pernice bianca
//ramarro

const in_direttiva = ref(false)

const specie_in_direttiva = [
  75, //Coturnice
  34, //Biacco
  127, //Lepre variabile
  167, //Parnassius apollo
  11, //Gracchio corallino
  72, //Coronella austriaca
  225, //stambecco
  280, //Euplagia quadripunctaria
  87, //Fagiano di monte
  207, //Rana temporaria
  38, //camoscio
  279, //Euphidryas aurinia
  182, //Picchio nero
  132, //Lucertola
  176, //Pernice bianca
  203, //ramarro
]




const browserSession = useBrowserSession()



const specie_filtered = computed(() => {
  // debugger

  const emptyArray = []

  if (!("classe_id" in properties.value)) return emptyArray
  if (properties.value.classe_id === null) return emptyArray

  const classe = baseData.lookup.classefauna.find((item) => item.value == properties.value.classe_id)

  // console.log(classe)

  // const specie_filtered_raw = baseData.lookup["speciefauna" + classe.label.toLowerCase()]
  let specie_filtered = baseData.lookup["speciefauna" + classe.label.toLowerCase()]

  if (in_direttiva.value){
      specie_filtered = specie_filtered.filter((e)=> specie_in_direttiva.includes(e.value))
  }


  // const specie_filtered = specie_filtered_raw.filter((item) => {
  //   return !item.label.toLowerCase().includes("sconosciuto")
  // })

  return specie_filtered

})



// const totalecontofauna = computed(() => {

//   if (!properties) return 0

//   let tot = 0
//   tot = tot + (properties?.value?.q_male || 0)
//   tot = tot + (properties?.value?.q_female || 0)
//   tot = tot + (properties?.value?.q_young || 0)
//   tot = tot + (properties?.value?.q_kid || 0)
//   tot = tot + (properties?.value?.q_undefined || 0)

//   // console.log("totalecontofauna called") 
//   return tot
// })




const classeChanged = async () => {
  await nextTick()

  // console.log("classeChanged, saved", properties.value.specie_id)

  if (properties.value?.classe_id) {
    properties.value.specie_id = specie_filtered.value[0]?.value
    specieChanged()
  }

  if (properties.value.classe_id !== "speciefaunauccelli") {
    properties.value.quota = 0
  }


  browserSession.settings.defaults[properties.value.model].classe_id = properties.value.classe_id

  setLabel()
}

const specieChanged = async () => {

  await nextTick()
  // console.log("specieChanged, saved", properties.value.specie_id)
  browserSession.settings.defaults[properties.value.model].specie_id = properties.value.specie_id

  setLabel()
}


const setLabel = () => {
  const actualSpecie = specie_filtered.value.find((item) => item.value == properties.value.specie_id)
  if (actualSpecie) {
    properties.value.label = actualSpecie.label
  }
  else {
    properties.value.label = "Sconosciuto"
  }
}



const loadDefaults = () => {
  // console.log("loadDefaults()")

  if (browserSession.settings.defaults?.[properties.value.model]?.classe_id) {
    // console.log("classe_id FOUND!!!")
    // console.log(browserSession.settings.defaults[properties.value.model].classe_id)
    properties.value.classe_id = browserSession.settings.defaults[properties.value.model].classe_id
  }
  if (browserSession.settings.defaults?.[properties.value.model]?.specie_id) {
    // console.log("specie_id FOUND!!!")
    // console.log(browserSession.settings.defaults[properties.value.model].specie_id)
    properties.value.specie_id = browserSession.settings.defaults[properties.value.model].specie_id
  }

  properties.value.segni_id = baseData.lookup.segni[0].value

}



onMounted(() => {
  // console.log("mounted")
  if (totalecontofauna.value === 0) {
    properties.value.q_male = 0
  }
  if (props.isNew) {
    loadDefaults()
  }

  setLabel()
})

</script>
